import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LoggedInUserContextProvider } from "./context/loggedInUserContext";
import { BrowserRouter } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FoundedAuctionsProvider } from "./context/foundedAuctionsContext";
import { SearchedAuctionParamsProvider } from "./context/searchedAuctionsParams";
import { LoadScript } from "@react-google-maps/api";
import OverlayLoading from "./components/overlayLoading";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <LoggedInUserContextProvider>
    <SearchedAuctionParamsProvider>
      <FoundedAuctionsProvider>
        <BrowserRouter>
          <ToastContainer />
          <LoadScript
            libraries={["places"]}
            loadingElement={<OverlayLoading />}
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_PLACES_API_KEY!}
          >
            <App />
          </LoadScript>
        </BrowserRouter>
      </FoundedAuctionsProvider>
    </SearchedAuctionParamsProvider>
  </LoggedInUserContextProvider>
);
reportWebVitals();
